import type { RestTransition } from './restTransition';
import type { DraftEntry } from './state/loggerDraftTypes';

// The transition's caption — "→ Set 3/4" or "→ <exercise>" — shown on the rest
// row for as long as the rest lasts (MX-5 D8). It lives apart from
// restTransition on purpose: that file decides WHERE the focus goes and stays
// free of i18n, so it can be unit-tested as arithmetic. This one is the only
// place that turns the decision into words, and it needs `t` and the exercise
// name resolver to do it.
//
// Returns null for `done`: nothing is pending, so there is nothing to point at.
// Since TM-12 a rest IS armed there, so the rest row does appear on a last set —
// it simply shows the countdown with no caption, which is the honest rendering
// of "no next set", not an omission.
export function restCueText({
  transition,
  entries,
  t,
  resolveName,
}: {
  transition: RestTransition;
  entries: readonly DraftEntry[];
  t: (k: string, opts?: Record<string, unknown>) => string;
  resolveName: (slug: string, fallback: string) => string;
}): string | null {
  if (transition.kind === 'set') {
    return t('mobile.timeline.cueNextSet', {
      n: transition.setNumber,
      total: transition.total,
      defaultValue: '→ Set {{n}}/{{total}}',
    });
  }
  if (transition.kind === 'exercise') {
    const target = entries[transition.entryIdx];
    return t('mobile.timeline.cueNextExercise', {
      name: resolveName(transition.exerciseId, target?.exerciseName ?? ''),
      defaultValue: '→ {{name}}',
    });
  }
  return null;
}
